import { api } from "./api";

export const ACTIVE = ["queued", "running"];
export const isActive = (j) => j && ACTIVE.includes(j.status);

/** Poll a job until terminal. Resolves with job.result; rejects with Error(job.error) on failure. */
export async function waitForJob(jobId, { onUpdate, intervalMs = 2000, timeoutMs = 20 * 60 * 1000 } = {}) {
  const t0 = Date.now();
  for (;;) {
    const j = await api(`/jobs/${jobId}`);
    onUpdate?.(j);
    if (!isActive(j)) {
      if (j.status !== "succeeded") { const e = new Error(j.error || `job ${j.status}`); e.job = j; throw e; }
      return j.result;
    }
    if (Date.now() - t0 > timeoutMs) throw new Error("job is taking longer than expected; check the Jobs panel");
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}

/** Accepts either a 202 {job_id,...} envelope or a plain result; returns the final result. */
export async function settle(resp, opts) {
  if (resp && resp.job_id) return { ...(await waitForJob(resp.job_id, opts)), _envelope: resp };
  return resp;
}

/** Subscribe to live job updates: SSE via fetch (cookie or bearer), falling back to 2 s polling. Returns unsubscribe. */
export function subscribeJobs(onJob, { all = false } = {}) {
  let stopped = false;
  let pollTimer = null;
  const token = localStorage.getItem("cx_token");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const poll = async () => {
    if (stopped) return;
    try { (await api(`/jobs?limit=30${all ? "&all=true" : ""}`)).forEach(onJob); } catch { /* ignore */ }
    pollTimer = setTimeout(poll, 2000);
  };
  (async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/jobs/stream${all ? "?all=true" : ""}`, { headers, credentials: "include" });
      if (!res.ok || !res.body) throw new Error("no stream");
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      while (!stopped) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n"); buf = parts.pop();
        for (const p of parts) { const line = p.split("\n").find((l) => l.startsWith("data:")); if (line) { try { onJob(JSON.parse(line.slice(5))); } catch { /* ignore */ } } }
      }
      if (!stopped) poll();
    } catch { if (!stopped) poll(); }
  })();
  return () => { stopped = true; if (pollTimer) clearTimeout(pollTimer); };
}
